// extracted by mini-css-extract-plugin
export default {"contents":"oF-z","sectionHeading":"pF-z"};